import React from 'react';
import { useSelector } from 'react-redux';
import StrategiesList from 'components/StrategiesList';
import StrategyRegister from 'components/StrategyRegister';
import { RootState } from 'store';
import { FORM_MODE } from 'shared/enums';

const Strategy: React.FC = () => {
  const { mode } = useSelector(
    (state: RootState) => state.selectedStrategyModeNavigation,
  );

  const editMode = [FORM_MODE.create, FORM_MODE.edit, FORM_MODE.view];

  return (
    <React.Fragment>
      {mode === FORM_MODE.list && <StrategiesList />}
      {editMode.includes(mode) && <StrategyRegister />}
    </React.Fragment>
  );
};

export default Strategy;
